module.exports = __webpack_public_path__ + "static/iteur-c542ca431f0a61d04f348ec36e329cb4.svg";